enum SideBarIcons {
	ALL = 'all',
	APPLICATIONS = 'applications',
	COMPANIES = 'comapnies',
	COMPANY_RESOURCES = 'companyResources',
	DOCUMENTS = 'documents',
	FAVORITES = 'favorites',
	GROUPS = 'groups',
	INBOX = 'inbox',
	INVOICING = 'invoicing',
	LOCATION = 'LocationIcon',
	JOB_BOARD = 'jobBoard',
	JOB_POSTINGS = 'jobPostings',
	MANAGE_COMPANY = 'manageCompany',
	MANAGERS = 'managers',
	PERSONAL = 'personal',
	PROJECTS = 'projects',
	MANAGE_PROJECTS = 'ManageProject',
	MARKETPLACE = 'MarketplaceIcon',
	PROJECTS_DOCUMENTS = 'projectsDocuments',
	SCHEDULER = 'scheduler',
	ALL_PROJECTS = 'talentHunt',
	RESOURCES = 'companyResources',
	TALENT_DIRECTORY = 'talentDirectory',
	MY_TALENT_DIRECTORY = 'MyDirectoryTalent',
	TALENT_HUNT = 'talentHunt',
	TIME_SHEET = 'timeSheet',
	NETWORK = 'talentDirectory',
	CONNECTIONS = 'myTalentDirectory',
	JOB_BLISS_MARKET_PLACE = 'jobBlissMarketPlace',
	POSTINGS = 'jobPostings',
	CALENDAR = "calendarNewIcon",
	RESOURCE_ICON = 'Resource',
}
export default SideBarIcons;
